import React, { useEffect, useRef } from 'react';
import { useSlidesContent, useSlidesUI } from '../../context';
import SlideRenderer from '../SlideRenderer';
import styles from './styles.module.css';
import { Grid } from '@mui/material';

function handleZoom(
  zoom: number,
  elementRef: React.RefObject<HTMLDivElement>,
  type: string,
): React.EffectCallback {
  return () => {
    const scale = zoom / 100;

    if (elementRef.current) {
      const element = elementRef.current.children[0] as HTMLElement;
      elementRef.current.style.transform = `scale(${scale})`;

      let originalWidth = element.scrollWidth;
      let originalHeight = element.scrollHeight;

      if (scale > 1) {
        originalWidth = element.scrollWidth * scale;
        originalHeight = element.scrollHeight * 1.25;
      } else {
        originalWidth = element.scrollWidth * scale;
        originalHeight = element.scrollHeight * scale;
      }

      if (type === 'premium_report') {
        elementRef.current.style.width = `${originalWidth}px`;
        elementRef.current.style.height = `${originalHeight}px`;
      } else {
        elementRef.current.style.width = `${originalWidth}px`;
        elementRef.current.style.height = `${originalHeight}px`;
      }
    }
  };
}

const Viewport = React.memo((): React.ReactElement => {
  const { currentSlide, type } = useSlidesContent();
  const { zoom } = useSlidesUI();
  const viewportInnerRef = useRef<HTMLDivElement>(null);

  useEffect(handleZoom(zoom, viewportInnerRef, type), [zoom]);

  return (
    <Grid
      container
      className={`${styles.viewport} ${type === 'premium_report' ? styles.premiumReport : ''}`}
    >
      <Grid item ref={viewportInnerRef} className={styles.viewportInner}>
        <SlideRenderer slide={currentSlide} type={type} />
      </Grid>
    </Grid>
  );
});

export default Viewport;
